import React from 'react';
import frame from "../../../assets/img/foot_supplement/frame.png";


const vegetarian_food_recommendedHealth = function () {
  return (
    <>
      <p className="nutritionHead2">รูปแบบการกินเพื่อสุขภาพที่แนะนำ</p>
      <p className="nutritionText3">
        การกินแบบ 2:1:1 คือการแบ่งสัดส่วนในจานอาหารออกเป็นหมวดต่าง ๆ แล้วเลือกกินหมวดต่าง ๆ นี้ให้ครบถ้วน โดยไม่จำกัดว่าต้องกินเพียงอย่างใดอย่างหนึ่ง ตามปกติของการคุมอาหาร เราจะมีอิสระในการเลือกกินอาหารโดยอิงตามหลักการแบ่งประเภทของอาหารต่าง ๆ ซึ่งการกินอิงตามแนวทางนี้จะช่วยให้ได้รับโปรตีนเพียงพอมากขึ้น ได้คาร์บไม่มากเกินไปและได้ประโยชน์จากอาหารเน้นพืชอย่างเต็มที่
      </p>
      <p className="nutritionText3">
        <span className="bold">    แนวทางการปฏิบัติมีดังนี้</span>
        <li>2 ส่วนแรก คือ สัดส่วนของผักต่างๆ เน้นที่ผักใบ ผักกินก้าน ดอก เช่น ผักบุ้ง ดอกกะหล่ำ ดอกขจร กะหล่ำปลี</li>
        <li>1 ส่วนต่อมา คือ สัดส่วนของแหล่งคาร์โบไฮเดรต ควรเลือกเป็นข้าวไม่ขัดสี ธัญพืชต่างๆ คีนัว ลูกเดือย หรือขนมปังโฮลวีต เส้นโฮลวีต </li>
        <li>1 อีกส่วนคือ สัดส่วนของแหล่งโปรตีน หากเลือกกินอาหารเน้นพืชแล้ว จะมีแหล่งโปรตีนที่แนะนำคือ เต้าหู้ ถั่วต่างๆ เทปเป้ นมถั่วเหลือง เนื้อ Plant-based โปรตีนเกษตร โดยควรกินให้ได้ปริมาณพอๆ กับแหล่งคาร์โบไฮเดรต</li>
      </p>
      <div className="centerImage ImageTop">
        <img src={frame} alt="vector" className="col-12 col-sm-12  col-md-8 col-lg-8" />
      </div>
      <p className="border-bottom3 margin-leftRight"></p>
      <p className="nutritionHead2">เมนูตัวอย่างในมื้อต่าง ๆ สำหรับการกินอาหารเน้นพืช (Plant-Based Diet)</p>
      <p className="nutritionText4">
        **เป็นเมนูที่อิงวัตถุดิบจากพืชเป็นหลัก ยังมีการบริโภคผลิตภัณฑ์จากสัตว์บ้างได้**
      </p>
      <div className="centerImageHead ">
        <div className="col-12 col-sm-12 colomd-12 col-lg-12">
          <table>
            <tbody>
            <tr className="head-table head-tableText">
                <td className="col-2">มื้อ</td>
                <td className="col-6">เมนูตัวอย่าง</td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เช้า
                </td>
                <td>
                  -ไข่คนเต้าหู้ (สำหรับผู้ที่ยังเลือกกินไข่ได้)
                  -มัฟฟินข้าวโอ๊ต / มัฟฟินกล้วย กินกับนมถั่วเหลืองสูตรโปรตีนสูง
                  -บาร์ธัญพืชรวม กินกับนมถั่วเหลืองสูตรหวานน้อย
                  -Overnight oat ในนมถั่วเหลือง กินกับกล้วยหอมและเบอร์รี่รวม
                  -พุดดิ้งเมล็ดเจียจากนมถั่วเหลือง โรยอัลมอนด์สไลซ์
                  -นมถั่วเหลืองอุ่นร้อน กินกับขนมปังหน้าไข่คนผักรวม หรือผักโขม
                  -กราโนลาสูตรหวานน้อย ในนมอัลมอนด์ หรือนมถั่วเหลืองหวานน้อย
                  -ผัดบรอกโคลีใส่ไข่ หรือเต้าหู้ ใส่ข้าวโพดเม็ดแกะ เห็ดหอมหั่นและถั่วลันเตา
                  -ข้าวผัดรวมผักใส่เห็ดรวม (เห็ดฟาง เห็ดนางฟ้า เห็ดหอม) กินกับซุปเต้าหู้มิโสะ
                  -ขนมปังปิ้งหน้ากล้วยหอมหั่น ครีมโกโก้ตามชอบและกาแฟดำ
                </td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เที่ยง
                </td>
                <td>
                  -ข้าวกล้องผสมดอกกะหล่ำผัด ถั่วดำต้มและข้าวโพด ปรุงรสแบบจีน (น้ำมันงา ซีอิ๊ว)
                  -ขนมปังปิ้ง หน้าอะโวคาโดหั่น น้ำผึ้งเล็กน้อย อาจใส่ชีสก็ได้
                  -ขนมปังโฮลวีตย่าง ทาเนยถั่ว และซุปครีมเห็ด / ซุปครีมบรอกโคลี
                  -ซุป Minestrone กินกับสปาเกตตี้ผัดพริกแห้ง ใส่เห็ดหอม ถั่วแขกและเต้าหู้
                  -สลัดผักรวมใส่เห็ด และเทมเป้ น้ำสลัดตามชอบ
                  -สลัดผักรวมคลุกทูน่ากระป๋องในน้ำแร่ หรือไข่ต้ม
                  -ข้าวผัดธัญพืชรวม ใส่เต้าหู้แผ่น จิ้มเทริยากิ
                  -เบอร์เกอร์ผัก เนื้อ Plant-based เสริมผักตามใจชอบ
                  -แซนด์วิชไส้มะเขือเทศและชีส (มอสซาเรลล่าและเชดดาร์ชีส) กินกับสลัดผักที่ชอบ
                  -แซนวิชไส้เนื้อ Plant-based เสริมสลัดผักตามใจชอบ
                  -ผัดกะเพราเห็ดรวมราดข้าว กินกับแกงส้มผักรวมใส่เต้าหู้
                </td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เย็น
                </td>
                <td>
                  -ราดหน้าเส้นหมี่ผักรวม ใส่เห็ดหอมและโปรตีนเกษตร
                  -ผัดผักรวมใส่เต้าหู้ (แคร์รอต ถั่วลันเตา เห็ดหอมแห้ง)
                  -ผัดคะน้าเต้าหู้ยี้ กินกับเห็ดรวมและเต้าหู้ย่าง
                  -ผักแท่งรวม จิ้มกินกับ Hummus และกินโยเกิร์ตปิดท้าย
                  -พาสต้าโฮลวีตผัดซอสตามชอบ ผักรวมย่าง (มะเขือเทศ เห็ด หน่อไม้ฝรั่ง)
                  -ผัดผักรวมใส่โหระพา เห็ดรวมและเต้าหู้ก้อน กินกับข้าวคีนัว
                  -ยำผักโขมน้ำมันงา กินกับเห็ดรวมย่างและเต้าหู้ย่าง
                  -สลัดผักรวมแอปเปิ้ล เต้าหู้ น้ำสลัดงาและอะโวคาโด
                  -เห็ดรวม ฟักทอง หน่อไม้ฝรั่งและเต้าหู้ย่าง กินกับน้ำสลัดทีชอบ
                  -เต้าหู้ย่างซอสกระเทียม กินกับผักรวมย่างและผลไม้สด
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p className="nutritionHead2">เมนูตัวอย่างในมื้อต่าง ๆ สำหรับการกินแบบ Strict Vegan</p>
      <p className="nutritionText4">
        **เป็นเมนูที่อิงวัตถุดิบจากพืชเท่านั้น**
      </p>
      <div className="centerImageHead ">
        <div className="col-12 col-sm-12 colomd-12 col-lg-12">
          <table>
            <tbody>
              <tr className="head-table head-tableText">
                <td className="col-2">มื้อ</td>
                <td className="col-6">เมนูตัวอย่าง</td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เช้า
                </td>
                <td>
                  -มัฟฟินข้าวโอ๊ต กินกับนมถั่วเหลืองสูตรโปรตีนสูง (ใช้เนยน้ำมันรำข้าว)
                  -โจ๊กข้าวโอ๊ต ต้มกับนมถั่วเหลือง เสริมผงโปรตีนถั่วเหลือง
                  -บาร์ธัญพืชรวม กินกับนมถั่วเหลืองสูตรหวานน้อย
                  -Overnight oat ในนมอัลมอนด์หวานน้อย ใส่เมล็ดฟักทองและถั่วอบ 1 ฝ่ามือ
                  -พุดดิ้งเมล็ดเจียจากนมถั่วเหลือง โรยอัลมอนด์สไลซ์
                  -ขนมปังโฮลวีต 2-3 แผ่น กินกับผัดเต้าหู้นิ่มกับซอสงาขาวและงาคั่ว
                  -กราโนลาสูตรหวานน้อย ในนมอัลมอนด์ หรือนมถั่วเหลืองหวานน้อย
                  -ผัดดอกกะหล่ำใส่เต้าหู้ แคร์รอตหั่นเต๋าและเห็ดหอมหั่น
                  -ข้าวผัดรวมผักใส่เห็ดรวม กินกับซุปเต้าหู้มิโสะ
                  -ขนมปังปิ้งหน้ากล้วยหอมหั่น เนยถั่ว กาแฟดำใส่น้ำตาลเทียม
                </td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เที่ยง
                </td>
                <td>
                  -ข้าวกล้องผสมคีนัวและดอกกะหล่ำผัด ใส่เต้าหู้ก้อน
                  -ขนมปังปิ้ง หน้าอะโวคาโดหั่น และเนยถั่ว
                  -ซุปมะเขือเทศ / ซุปบรอกโคลี / ซุปดอกกะหล่ำ
                  -สลัดผักรวมใส่เห็ด และเทมเป้ น้ำสลัดตามชอบ
                  -สลัดผักรวมคลุกหน้าเต้าหู้ย่าง น้ำสลัดงาญี่ปุ่น
                  -ข้าวผัดธัญพืชรวม หน้าเต้าหู้แผ่น ซอสเขียวหวาน
                  -เบอร์เกอร์ผัก เนื้อ Plant-based เสริมผักสลัด
                  -แซนด์วิชไส้มะเขือเทศ และเต้าหู้ย่าง น้ำสลัดญี่ปุ่น
                  -แซนด์วิชไส้เนื้อ Plant-based เสริมสลัดผักตามใจชอบ
                  -ผัดกะเพราเห็ดรวมราดข้าว กินกับแกงส้มผักรวมใส่โปรตีนเกษตร
                </td>
              </tr>
              <tr>
                <td className="center-tebleRow">
                  เย็น
                </td>
                <td>
                  -ราดหน้าเส้นหมี่ผักรวม ใส่เห็ดหอมและโปรตีนเกษตร
                  -ผัดผักรวมใส่เต้าหู้ (แคร์รอต ถั่วลันเตา เห็ดหอมแห้ง)
                  -ผัดคะน้าเต้าหู้ยี้ กินกับเห็ดรวมและเต้าหู้ย่าง
                  -ผักแท่งรวม จิ้มกินกับ Hummus และนมถั่วเหลืองหวานน้อย 1 กล่อง
                  -พาสต้าโฮลวีตผัดซอสตามชอบ ผักรวมย่าง (มะเขือเทศ เห็ด หน่อไม้ฝรั่ง)
                  -ผัดผักรวมใส่โหระพา เห็ดรวมและเต้าหู้ก้อน กินกับข้าวคีนัว
                  -ยำผักโขมน้ำมันงา กินกับเห็ดรวมย่างและเต้าหู้ย่าง
                  -สลัดผักรวมแอปเปิ้ล เต้าหู้ น้ำสลัดงาและอะโวคาโด
                  -เห็ดรวม ฟักทอง หน่อไม้ฝรั่งและเต้าหู้ย่าง กินกับน้ำสลัดทีชอบ
                  -เต้าหู้ย่างซอสเทริยากิ กินกับผักรวมย่างและผลไม้สด
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
export default vegetarian_food_recommendedHealth;